// SPDX-License-Identifier: AGPL-3.0-or-later

import {Endpoints} from '@app/features/app/constants/Endpoints';
import {http} from '@app/features/platform/transport/RestTransport';
import {failureCode} from '@app/features/platform/utils/ResponseInspection';
import {APIErrorCodes} from '@fluxer/constants/src/ApiErrorCodes';
import type {GuildTagCardResponse, GuildTagListResponse} from '@fluxer/schema/src/domains/guild/GuildTagSchemas';

// The server takes at most 50 IDs and leaves out guilds without a visible tag.
export async function fetchTags(ids: ReadonlyArray<string>): Promise<GuildTagListResponse> {
	const response = await http.get<GuildTagListResponse>(Endpoints.GUILD_TAGS, {query: {ids: ids.join(',')}});
	return response.body;
}

// Null for every guild that is not listed in discovery: the server names no other guild to someone outside it.
export async function fetchCard(guildId: string): Promise<GuildTagCardResponse | null> {
	try {
		const response = await http.get<GuildTagCardResponse>(Endpoints.GUILD_TAG_CARD(guildId));
		return response.body;
	} catch (error) {
		if (failureCode(error) === APIErrorCodes.UNKNOWN_GUILD) return null;
		throw error;
	}
}

// The worn guild comes back through USER_UPDATE, like every other user field.
export async function wear(guildId: string | null): Promise<void> {
	await http.put(Endpoints.USER_GUILD_TAG, {body: {guild_id: guildId}});
}
